import { startsWith } from 'lodash-es';

const PREFIX = '/legacy/#';

export const parseLegacyUrl = (url: string, isStandalone: boolean): string => {
    if (!isStandalone) {
        return url;
    }
    const path = startsWith(url, '/') ? url : `/${url}`;

    return `${PREFIX}${path}`;
};
